export default {
    name: "Application Documents",
    pageInfo: {
      text: "Below, you will find a summary of the documents that you have uploaded to this application and their respective document categories below.",
      coloring: "grey"
    },
    sections: [
      {
        fields: [
            {
                machine_name: "files",
                widget: "application_documents",
                validate: []  
            }
        ]
      }
    ]
  };
  